import { ModalSairSemSalvar } from "@/shared/components/ModalSairSemSalvar";
import { useProtecaoFormulario } from "@/shared/hooks/useProtecaoSaida";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMinisterios } from "@/core/hooks/useMinisterios";
import { FormularioComunicado } from "@/modules/comunicados/components/FormularioComunicado";
import {
  usePodeGerenciarComunicados,
  usePublicarComunicado,
} from "@/modules/comunicados/hooks/useComunicados";
import type { DadosComunicado } from "@/modules/comunicados/services/comunicadosService";

/** Novo comunicado. Só líder/gestor do elo publica; quem decide de verdade é a RPC `comunicado_publicar`. */
export function NovoComunicadoPage() {
  const navigate = useNavigate();
  const { data: podeGerenciar, isLoading: carregandoPermissao } = usePodeGerenciarComunicados();
  const { data: ministerios } = useMinisterios();
  const publicar = usePublicarComunicado();
  const [erro, setErro] = useState<string | null>(null);
  const protecao = useProtecaoFormulario();

  const opcoesMinisterio = (ministerios ?? [])
    .filter((m) => m.ativo)
    .map((m) => ({ id: m.id, nome: m.nome }));

  async function aoEnviar(dados: DadosComunicado) {
    setErro(null);
    try {
      await publicar.mutateAsync(dados);
      protecao.liberar();
      navigate("/comunicados", { state: { aviso: "Comunicado publicado." } });
    } catch (e) {
      setErro(e instanceof Error ? e.message : "Não foi possível publicar o comunicado.");
    }
  }

  if (carregandoPermissao) {
    return (
      <main className="mx-auto w-full max-w-2xl px-4 pb-24 pt-6 sm:px-6 sm:pt-10">
        <p className="text-sm text-muted">Carregando...</p>
      </main>
    );
  }

  if (!podeGerenciar) {
    return (
      <main className="mx-auto w-full max-w-2xl px-4 pb-24 pt-6 sm:px-6 sm:pt-10">
        <p
          role="alert"
          className="rounded-xl border border-border bg-surface p-5 text-sm text-muted"
        >
          Só quem lidera ou gerencia o elo Comunicados pode publicar.{" "}
          <Link to="/comunicados" className="font-bold text-primary hover:underline">
            Voltar aos comunicados
          </Link>
        </p>
      </main>
    );
  }

  return (
    <main className="mx-auto w-full max-w-2xl px-4 pb-24 pt-6 sm:px-6 sm:pt-10">
      <header className="mb-5">
        <h1 className="text-2xl font-black tracking-tight text-primary">Novo comunicado</h1>
        <p className="mt-1 text-sm text-muted">Escreva um aviso para a igreja.</p>
      </header>
      <div {...protecao.areaProps}>
        <FormularioComunicado
          ministerios={opcoesMinisterio}
          carregando={publicar.isPending}
          erro={erro}
          onSubmit={(dados) => void aoEnviar(dados)}
          onCancelar={() => navigate("/comunicados")}
        />
      </div>
      <ModalSairSemSalvar
        aberto={protecao.pedindoSaida}
        onSair={protecao.confirmarSaida}
        onContinuar={protecao.continuarEditando}
      />
    </main>
  );
}
